import React, {useState, useEffect, useContext} from 'react'
import {proto,url} from '../Helpers/api';
import {get,groupBy,sortBy,keyBy,mapValues,merge,range} from 'lodash-es';
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import MetricasGrupo from '../App/Metricas/Grupo';
import Seletor from '../App/Seletor';
import SeletorAno from '../Common/SeletorAno';
import MetricasUI from '../App/Metricas/EmpresaUI';
import {fetch as authFetch, m_fetch} from '../Helpers/auth';
import {MainContext} from '../App';

const esteAno = () => new Date().getFullYear()
const primeiroAno = lista => {
  let _1 = Object.keys(lista)
  if (!_1.length) return esteAno()
  return _1.map(r=>parseInt(r)).sort((a,b)=>a-b)[0]
}

const prepare = data => (
  mapValues(groupBy(data, "ano"), d => (
    mapValues(keyBy(d, "mes"),({ano,mes,...o})=>o)
  ))
)

export default function Metricas (props) {
  let [ tab, setTab ] = useState(0);
  const changeTab = (e,val) => setTab(val)
  return (
    <>
    <Tabs
      value={tab}
      onChange={changeTab}
      indicatorColor="primary"
      textColor="primary"
      centered
    >
      <Tab value={0} label="Empresas" />
      <Tab value={1} label="Grupos" />
    </Tabs>
    {tab === 0 && <MetricasEmpresa {...props} /> }
    {tab === 1 && <MetricasGrupo {...props} /> }
    </>
  )
}

function MetricasEmpresa(props) {
  const [ empresa, setEmpresa ] = useState(null);
  const emp = get(empresa,"value")
  const [ ano, setAno ] = useState(esteAno());
  const [ verDetalhes, setVerDetalhes ] = useState(false);
  const [ opt, setOpt ] = useState([]);
  const { empresas } = props.data;
  const [ metricas, setMetricas ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const [ erro, setErro ] = useState(false);
  const { user:userCtx, setUser:setCtxUser, setNotification } = useContext(MainContext)

  // baixa as metricas caso a empresa esteja selecionada
  useEffect(() => {
    if (emp) {
      setMetricas([]);
      setLoading(true);
      m_fetch([
        `${proto}://${url}/main/metricas/pessoal/${emp}/1`,
        `${proto}://${url}/main/metricas/pessoal/${emp}/2`,
        `${proto}://${url}/main/metricas/pessoal/${emp}/3`,
        `${proto}://${url}/main/metricas/pessoal/${emp}/4`,
        `${proto}://${url}/main/metricas/pessoal/${emp}/5`,
        `${proto}://${url}/main/metricas/pessoal/${emp}/6`,
        `${proto}://${url}/main/metricas/pessoal/${emp}/7`,
        `${proto}://${url}/main/metricas/pessoal/${emp}/8`,
      ]).then(res => Promise.all(res.map(r=>r.json())))
        .then(res => res.map(prepare))
        .then(res => merge(...res))
        .then(res => {
          setMetricas(res);
          setLoading(false);
        })
        .catch(err => {
          // console.log(err)
          // console.log(Object.keys(err))
          setMetricas([]);
          setErro(true);
          setLoading(false)
          setNotification({
            type: "error",
            message: err.err || err.message,
            duration: 3000
          })

        })
    } else {
      setAno(esteAno());
      setVerDetalhes(false);
    }
  }, [emp])
  // gera lista de opções do seletor de empresas
  useEffect(() => {
    setOpt(sortBy(empresas,'Apelido').map(e => {
      let label = e.Cidade ? ` - ${e.Cidade} ` : " "
      label = e.Apelido + label + `(${e.Codigo})`
      return { value: e.Codigo, label, sublabel: e.RazaoSocial }
    }))
  }, [empresas])
  return (
    <div style={{
      padding: "10px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      <div style={{
        display: "grid",
        gridTemplateColumns: "440px 150px",
        gridGap: "25px",
        marginBottom: "10px"
      }}>
        <Seletor
          fullWidth
          label={"Empresa"}
          onChange={setEmpresa}
          value={empresa}
          placeholder="Selecione a empresa"
          suggestions={opt}
        />
        <SeletorAno
          value={ano}
          onChange={setAno}
          minValue={primeiroAno(metricas)}
          label="Ano"
        />
      </div>
      {erro ? 'ERRO AO CARREGAR OS DADOS' : (
        <MetricasUI {...props}
          metricas={metricas}
          empresa={emp}
          ano={ano}
          loading={loading}
          verDetalhes={verDetalhes}
          setVerDetalhes={setVerDetalhes}
        />
      )}
    </div>
  )
}
